var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup6536(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 434.354,
    height: 333,
    viewBox: "0 0 434.354 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4c9800;}.b{fill:#0070ad;}.c{fill:#9ece6f;}.d,.k{fill:none;stroke-linecap:round;stroke-linejoin:round;}.d{stroke:#22537f;stroke-width:2px;}.e{fill:#cbeffc;}.f{fill:#ffc55f;}.g{fill:#f95b03;}.h{fill:#ec961f;}.i{fill:#1c2229;}.j{fill:#ffaa83;}.k{stroke:#ed5738;stroke-width:6px;}.l{fill:#ed5738;}.m{fill:red;}.n{fill:#fff;}.o{fill:#1d5ef8;}.p{fill:#253238;}.q{fill:#22537f;}.r{fill:#1e5b89;}.s{fill:#4c91fc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-138.412 -63.774)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.866 63.774)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M481.315,79.1c0-.053,0-.105,0-.157a14.8,14.8,0,1,0-29.583,0c0,.027,0,.053,0,.081h0a26.1,26.1,0,0,1-5.679,16.523q-7.319,9.2-7.319,16.878a23.431,23.431,0,0,0,1.647,7.991h0a26.1,26.1,0,0,1-2.325,22.818q-6.181,9.939-6.181,17.72a32.344,32.344,0,0,0,2.67,11.7h0a26.1,26.1,0,0,1-1.847,23.069q-7.31,12.22-7.31,21.383c0,23.3,18.417,42.184,41.135,42.184S507.66,240.4,507.66,217.1q0-9.163-7.311-21.383h0a26.1,26.1,0,0,1-1.847-23.069,32.345,32.345,0,0,0,2.67-11.7q0-7.861-6.3-17.883h0a26.1,26.1,0,0,1-2.44-22.8,23.345,23.345,0,0,0,1.592-7.849q0-7.586-7.15-16.7h0A26.106,26.106,0,0,1,481.315,79.1Z",
    transform: "translate(-425.391 -63.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M508.015,332.684V311.413l14.936-19.508a.434.434,0,0,0-.689-.528L507.237,311a.432.432,0,0,0-.09.264V331.55L493.1,313.2a.434.434,0,0,0-.689.527l14.738,19.25v2a.435.435,0,0,0,.2.364V354.2l-.108.141a.433.433,0,0,0-.09.264v15.839L493.1,352.095a.434.434,0,0,0-.689.528l14.738,19.25v6.448a.435.435,0,0,0,.2.364v11.371a.433.433,0,0,0-.066.23V425.2a.434.434,0,0,0,.868,0V395.927a.432.432,0,0,0,.065-.23v-5.3l15.612-16.01a.434.434,0,0,0-.622-.606l-14.991,15.373V371.983a.434.434,0,0,0-.089-.264l-.108-.141v-14.41a.434.434,0,0,0,.2-.364v-2.309l14.738-19.25a.434.434,0,1,0-.689-.527l-14.049,18.35V333.089a.434.434,0,0,0-.089-.264Z",
    transform: "translate(-466.999 -205.165)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 107.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.051,339.966c-21.262,0-38.5-17.675-38.5-39.479s17.236-137.27,38.5-137.27,38.5,115.466,38.5,137.27S281.313,339.966,260.051,339.966Z",
    transform: "translate(-221.554 -163.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M297.207,432.7V415.874l14.936-19.508a.434.434,0,1,0-.689-.527l-15.025,19.625a.434.434,0,0,0-.089.264v15.839l-14.049-18.35a.434.434,0,1,0-.689.528l14.738,19.25v6.448a.434.434,0,0,0,.2.364v11.964l-14.246-18.608a.434.434,0,0,0-.689.528L296.537,453.2v17.925a.437.437,0,0,0-.065.23v34.914a.434.434,0,1,0,.868,0V476.994a.432.432,0,0,0,.066-.23v-5.3l15.612-16.01a.434.434,0,0,0-.622-.606l-14.99,15.373V433.1a.434.434,0,0,0-.09-.264Z",
    transform: "translate(-258.829 -307.727)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.005 48.971)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1090.051,369.966c-21.261,0-38.5-17.675-38.5-39.479s17.236-137.27,38.5-137.27,38.5,115.466,38.5,137.27S1111.313,369.966,1090.051,369.966Z",
    transform: "translate(-1051.554 -193.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1127.207,462.7V445.874l14.936-19.508a.434.434,0,1,0-.689-.527l-15.025,19.625a.434.434,0,0,0-.089.264v15.839l-14.049-18.35a.434.434,0,1,0-.689.528l14.738,19.25v6.448a.434.434,0,0,0,.2.364v11.964l-14.246-18.608a.434.434,0,0,0-.689.528l14.936,19.508v17.925a.437.437,0,0,0-.065.23v34.914a.434.434,0,1,0,.868,0V506.994a.432.432,0,0,0,.066-.23v-5.3l15.612-16.01a.434.434,0,0,0-.622-.606l-14.99,15.373V463.1a.433.433,0,0,0-.09-.264Z",
    transform: "translate(-1088.829 -337.727)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.438 264.433)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1013.836,692.22c-13.449,1.89-19.527-51.957-21.65-67.061s7.059-28.881,20.508-30.771,26.072,8.822,28.195,23.926S1027.285,690.33,1013.836,692.22Z",
    transform: "translate(-957.024 -594.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1056,744.863V665.984",
    transform: "translate(-996.887 -638.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1058.737,764.768c-10.1-6.067,16.362-47.62,23.5-59.505s21.117-16.6,31.214-10.535,12.493,20.62,5.352,32.506S1068.834,770.836,1058.737,764.768Z",
    transform: "translate(-997.176 -655.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1063.864,827.114c-3.551-7.616,41.466-27.6,54.033-33.461s25.633-4.437,29.185,3.179-3.757,18.54-16.324,24.4S1067.415,834.73,1063.864,827.114Z",
    transform: "translate(-1001.651 -715.941)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1069,861.428l48.614-14.944",
    transform: "translate(-1004.969 -751.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1067,805.126l38.967-44.642",
    transform: "translate(-1003.726 -697.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M962.736,774.188c-5.623,6.245-41.609-27.385-51.913-36.663s-14.1-21.862-8.477-28.107,18.534-3.786,28.839,5.493S968.358,767.944,962.736,774.188Z",
    transform: "translate(-899.744 -663.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1012.1,815.465l-24.4-30.833",
    transform: "translate(-954.421 -712.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M965.776,839.457c-1.45,5.41-37.393-4.85-47.558-7.574s-17.23-9.318-15.78-14.728,10.865-7.588,21.03-4.865S967.226,834.046,965.776,839.457Z",
    transform: "translate(-901.302 -729.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1000.429,861.671,959,847.484",
    transform: "translate(-936.584 -751.651)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.628 114.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.185)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M438.189,516.736a2.144,2.144,0,0,1-2.573,2.054,3.87,3.87,0,0,1-3.021-3.03L414.5,425.674a12.731,12.731,0,0,1,11.631-15.207q.592-.04,1.187-.026a13.278,13.278,0,0,1,12.973,13.576Z",
    transform: "translate(-401.114 -344.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M400.438,322.851c-9.192,3.338-24.722-11.51-20.065-28.262s8.782-26.8,4.391-32,11.486-2.655,11.486,7.327,1.209-24.932,13.379-34.39q3.186,17.37,11.764,27.063c8.577,9.693,6.779,17.346,3.215,26.586q6.188,1.22,5.466-3.061c5.493,5.2.148,27.074-12.629,33.091S409.63,319.513,400.438,322.851Z",
    transform: "translate(-379.522 -235.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M440.949,427.634q-.627.361-1.281.669c-12.777,6.016-7.815.3-17.007,3.642a9.59,9.59,0,0,1-6.238-.1l-.992-6.147q-.074-.455-.114-.915a12.662,12.662,0,0,1,11.511-13.718q.36-.031.721-.043a12.876,12.876,0,0,1,13.27,12.469Z",
    transform: "translate(-401.745 -344.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M438.117,428.263l4.216-8.238a1.135,1.135,0,0,1,2.021,1.034l-4.216,8.238A1.135,1.135,0,0,1,438.117,428.263Z",
    transform: "translate(-415.861 -349.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M449.158,433.778l4.216-8.238a1.135,1.135,0,0,1,2.021,1.034l-4.216,8.238A1.135,1.135,0,0,1,449.158,433.778Z",
    transform: "translate(-422.725 -353.263)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.796 93.186)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M435.315,601.013c5.331-3.2-5.492-21.314-7.5-22.187-3.347-1.457-8.516,6.632-9.133,10.526-.771,4.869,6.821,11.383,10.74,13.859.318.2,2.069,1.713,2.531,1.637.415-.068-.082-2.047.387-2.256A25.831,25.831,0,0,0,435.315,601.013Z",
    transform: "translate(-418.631 -527.843)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M631.117,647.19l-4.385-7Z",
    transform: "translate(-548.003 -566.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M460.27,503.217c13.273,3.5,33.07,9.054,49.618,15.238-7.3-23.036-14.3-54.227-9.286-64.731,7.247-15.18,17.666-9.345,23.158-.575,5.365,8.567,24.239,72.554,18.351,89.665,2.275,10.3-4.03,15.121-17.288,12.408q-14.067-2.879-67.485-34.425a5.311,5.311,0,0,1-4.787-2.045,7.9,7.9,0,0,1-.67-1.192q-5.128-3.053-10.593-6.352a30.3,30.3,0,0,1-.639-7.089l-.052-.022c-5.636-2.483,3.409-13,6.907-11.718,2.324.855,5.332.387,9.078,3.759C458.217,497.612,459.479,500.216,460.27,503.217Z",
    transform: "translate(-431.165 -444.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M433.035,584.292a31.576,31.576,0,0,1,3.438-4.12,1.135,1.135,0,1,0-1.651-1.558,33.285,33.285,0,0,0-3.7,4.457,5.094,5.094,0,0,0-.751,1.644,1.688,1.688,0,0,0,.693,1.859c1.9,1.222,4.669,1.4,8.292.116q1.519-.536,2.623-1a9.973,9.973,0,0,0,.852,6.387,8.591,8.591,0,0,0,2.019,2.884,2.145,2.145,0,0,0,2.919.031,1.135,1.135,0,0,0-1.438-1.755c-.017-.012-.035-.026-.055-.042a6.912,6.912,0,0,1-1.41-2.124,8.37,8.37,0,0,1,.031-7.228,1.135,1.135,0,0,0-1.78-1.3,18.831,18.831,0,0,1-4.517,2.012c-2.7.952-4.623.944-5.9.34A5.351,5.351,0,0,1,433.035,584.292Zm13.373,8.99h0Z",
    transform: "translate(-425.899 -527.598)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.997 77.907)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M614.27,409.978c15.421-14.388,114.357-.072,121.052,12.723s-12.894,98.494-31.51,109.653-61.952,12.332-78.484-8.249S598.849,424.366,614.27,409.978Z",
    transform: "translate(-594.686 -403.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M593.672,480.643c-8.877.388-16.667-2.939-17.882-11.3-2.358-16.237,1.676-44.555,13.43-56.615,4.222-4.332,7.943-5.959,11.084-5.8,6.428-2.218,16.407-3.085,27.87-2.954,9.348.106-10.537,61.619,22.215,65.062,41.465,4.358,22.931-60.818,29.973-59.437,18.361,3.6,32.975,8.451,35.408,13.1,5.5,10.509-6.733,70.194-21.593,97.372-3.233,5.914,9.824,31.72,6.5,33.714-16.231,9.73-26.673,8.1-56.1,8.914s-46.423-13.646-45.954-19.338c.756-9.168,2.281-22.763.463-34.371C598.167,503.121,595.895,492.675,593.672,480.643Z",
    transform: "translate(-575.134 -403.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M710.6,475.8a1.589,1.589,0,0,1,3.167-.26c1.846,22.477,8.839,34.048,20.8,35.3,8.454.889,15.379-2.683,20.433-9.857,4.537-6.44,7.257-15.483,7.621-24.616a1.589,1.589,0,1,1,3.175.126c-.386,9.712-3.284,19.345-8.2,26.32-5.686,8.07-13.7,12.2-23.363,11.187C720.368,512.547,712.552,499.614,710.6,475.8Z",
    transform: "translate(-659.338 -447.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M591.415,579.97a37.317,37.317,0,0,1-15.925-8.78,1.135,1.135,0,0,1,1.52-1.686q7.337,6.617,14.984,8.224C592.429,579.275,593.311,579.97,591.415,579.97Z",
    transform: "translate(-575.115 -506.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M616.414,572.927a1.135,1.135,0,1,1-2.169.669c-2.48-8.038-3.514-13.826-3.075-17.456a1.135,1.135,0,1,1,2.253.272C613.034,559.639,614.022,565.174,616.414,572.927Z",
    transform: "translate(-597.469 -497.947)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.164)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.035 41.907)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M691.722,358.124c-4.063-1.288-11.381-7.735-10.22-12.764,1.206-5.225,5.378-8.724,9.317-7.814q.23.053.452.124.2-1.272.473-2.451c4.252-18.415,22.92-29.83,41.7-25.495S764,332.5,759.745,350.918s-26.015,48.563-44.793,44.228C702.47,392.265,694.449,374.871,691.722,358.124Z",
    transform: "translate(-681.379 -308.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M755.557,381.665l6.387,5.956a1.991,1.991,0,1,1-2.715,2.912l-6.387-5.956a1.991,1.991,0,0,1,2.715-2.912Z",
    transform: "translate(-725.412 -353.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M834.36,390.831l8.153-3.13a1.991,1.991,0,0,1,1.427,3.717l-8.153,3.13a1.991,1.991,0,1,1-1.427-3.717Z",
    transform: "translate(-775.69 -357.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M791.724,407.26q-4.623,11.191-1.676,14.323a11.881,11.881,0,0,0,5.657,3.758q-4.082,3.552-7.448,4c-3.366.449-8.589-2.155-5.216-4.15",
    transform: "translate(-743.902 -370.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M695.211,394.178a1.135,1.135,0,0,1,.653,2.174c-3.47,1.042-4.084,2.566-2.239,5.4a1.135,1.135,0,1,1-1.9,1.24C689.03,398.857,690.325,395.645,695.211,394.178Z",
    transform: "translate(-686.952 -361.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M756.9,481.339a1.135,1.135,0,1,1,.042-2.27c8.122.149,13.77,4.252,16.761,12.155a1.135,1.135,0,0,1-2.123.8C768.916,484.982,764.083,481.471,756.9,481.339Z",
    transform: "translate(-727.638 -414.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M722.7,488.6a1.135,1.135,0,0,1,2.156-.71c3.225,9.8,8.726,15.522,16.545,17.327,7.794,1.8,15.306-1.3,22.64-9.449a1.135,1.135,0,1,1,1.687,1.519c-7.844,8.715-16.158,12.146-24.838,10.142C732.238,505.431,726.159,499.1,722.7,488.6Z",
    transform: "translate(-707.033 -419.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M747.322,407.144l5.887-1.138-4.829-3.1A1.135,1.135,0,1,1,749.606,401l7.216,4.628a1.135,1.135,0,0,1-.4,2.069l-8.672,1.677a1.135,1.135,0,0,1-.431-2.229Z",
    transform: "translate(-721.803 -366.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 2.459,
    cy: 2.459,
    r: 2.459,
    transform: "translate(57.662 44.07)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M663.338,244.693l-4.853-1.989a1.589,1.589,0,1,1,1.205-2.94l1.833.751-1.548-1.435a1.589,1.589,0,1,1,2.161-2.33l2.492,2.31q.22-.526.478-1.027c5.443-10.515,9-13.268,19.538-8.7,18.168-41.5,46.011-36.593,53.655-14.89,10.719-13.441,20.516-13.3,27.739-8.552l1.727-3.059a1.589,1.589,0,1,1,2.767,1.562l-1.945,3.445a29.4,29.4,0,0,1,3.917,4.211l8.436-5.833a1.589,1.589,0,0,1,1.807,2.614l-8.429,5.828.073.117,6.221-2.068a1.589,1.589,0,0,1,1,3.016l-5.645,1.876a27.2,27.2,0,0,1,1.871,4.773c27.917-4.273,39.366,18.56,5.353,32.368,2.421,16.02-17.632,20.819-24.812,16.624-.423,14-12.158,21.566-18.3,21.764,1.372-2.191,3.766-8.789,4.746-13.034-2.142-7.845-3.759-10.11-2.982-19.439-6.226,4.139-17.7,5.226-28.277,6.871-4.707.732-20.15-1.062-24.862-7.74-1.621,7.022-1.66,14.352-6.585,24.285-3.994,1.313-2.153-11.567-4.578-13.994-2.854-2.857-6.616.505-8.513,1.212C667.971,268.6,662.439,255.244,663.338,244.693Z",
    transform: "translate(-657.498 -198.033)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.525 93.787)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M878.984,482.891c.293,8.163-3.7,51.327-20.343,77.219-3.646,5.673-2.677,8.624-5.393,13.037-10.5,17.055-28.128,20.235-28.128-10.891,0-7.836,6.2-14.661,7.54-21.695,4.6-24.079,15.25-61.38,25.981-68.75C872.508,462.288,878.613,472.55,878.984,482.891Z",
    transform: "translate(-808.066 -459.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M892.95,456.929c.314,10.145,2.093,26.824,2.144,42.021s-42.995,26.614-46.312,0,11.4-53.012,23.985-53.012S892.631,446.583,892.95,456.929Z",
    transform: "translate(-822.482 -445.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M891.259,588.417c-15.823,13.105-30.961,13.357-45.005.692a1.135,1.135,0,1,1,1.52-1.686c13.18,11.885,27.056,11.654,42.038-.755a1.135,1.135,0,1,1,1.448,1.748Z",
    transform: "translate(-820.971 -533.266)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M856.859,558.891c1.871-8.2,3.87-13.731,6.065-16.655a1.135,1.135,0,0,1,1.816,1.363c-1.951,2.6-3.863,7.887-5.667,15.8a1.135,1.135,0,0,1-2.213-.505Z",
    transform: "translate(-827.78 -505.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M846.852,651.637v-4.659a1.135,1.135,0,0,1,2.27,0v4.659a1.135,1.135,0,0,1-2.27,0Z",
    transform: "translate(-821.577 -570.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M894.981,660.663c1.47-3.79,1.472-9.763-.05-17.874-2.366-8.945-2.823-14.348-1.139-16.621a1.135,1.135,0,0,1,1.823,1.351c-1.085,1.465-.656,6.511,1.539,14.809,1.6,8.511,1.6,14.88-.057,19.155a1.135,1.135,0,1,1-2.116-.821Z",
    transform: "translate(-850.132 -557.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M782.486,583.03c-1.807-2.228-1.215-3.089-1.94-5.847-.25-.95.891-2.454.743-3.459-.11-.747-1.257-1.826-1.245-2.584.02-1.347.987-2.675,1.245-4.054.227-1.212-1.451-2.193-.743-4.161s2.681-2.182,3.4-3.22c.571-.826-2.386-2.044,0-4.429s9.476-3.281,13.012-1.61c-1.081,6.762,4.946,7.146,8.336,5.116.856-.513.585-4.67,1.9-4.67,1.1,0,3.983,0,5.514,1.164,9.009,6.848,11.9,11.737,10.813,25.727-.541,6.982-20,8.217-26.562,6.848C793.177,587.062,785.1,586.252,782.486,583.03Z",
    transform: "translate(-780.043 -512.377)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.293 70.733)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M824.038,536.74l9.251,1.966-3.017,14.624-9.251-1.966Z",
    transform: "translate(-802.287 -479.334)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 30.455,
    cy: 30.455,
    r: 30.455
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 27.05,
    cy: 27.05,
    r: 27.05,
    transform: "translate(3.405 3.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M833.214,413.48c-2.228,10.474-8.919,24.068-17.634,34.408a27.053,27.053,0,1,1,17.634-34.408Z",
    transform: "translate(-777.095 -391.217)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.889 12.485)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 14.754,
    cy: 14.754,
    r: 14.754
  }), /*#__PURE__*/React.createElement("circle", {
    className: "q",
    cx: 7.566,
    cy: 7.566,
    r: 7.566,
    transform: "translate(7.566 7.566)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 3.783,
    cy: 3.783,
    r: 3.783,
    transform: "translate(11.35 11.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 3.594,
    cy: 3.594,
    r: 3.594,
    transform: "translate(16.646 8.323)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.412 278.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M637.4,784.671q-9.7-26.093-28.4-26.093c-18.7,0-9.688-27.387-29.084-27.387-12.627,0-12.627,15.244-30.711,5.776-18.646-9.761.693-26.6-34.637-29.832s-27.214,29.832-41.761,29.832c-10.477,0-11.152-16.658-20.09-18.011s-10.16,9.7-16.857,8.313c-8.159-1.688-5.08-15.706-24.973-15.706s-13.128,27.077-17.977,30.051-11.084-6.956-17.78,4.821,4.9,17.318-4.849,17.318q-17.826,0-19.673,20.919,1.313,6.4,24.522,7.165c23.209.762,24.254-5.786,53.052-4.618s33.679,0,75.036,0,34.015,9.287,65.59,6.466,55.77,3.013,73.892,1.847Q657.592,794.574,637.4,784.671Z",
    transform: "translate(-270.332 -677.876)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.838 44.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M809.978,749.045c1.211.021,2.169,1.417,2.139,3.118s-1.169,10.69-2.38,10.669-2.036-9.044-2.006-10.745S808.767,749.023,809.978,749.045Z",
    transform: "translate(-785.353 -749.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M788.307,769.871c1.016-.66,2.59-.038,3.516,1.388s5.009,9.516,3.993,10.176-6.745-6.36-7.672-7.787S787.29,770.531,788.307,769.871Z",
    transform: "translate(-772.772 -761.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M775.124,791.736c1.034-1.108,3.133-.83,4.69.621s8.962,10.037,7.928,11.145-10.115-5.68-11.671-7.131S774.091,792.845,775.124,791.736Z",
    transform: "translate(-764.731 -775.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M767.455,815.759c1.064-1.362,3.478-1.255,5.39.24s11.179,10.512,10.115,11.874-12.056-5.447-13.968-6.942S766.391,817.121,767.455,815.759Z",
    transform: "translate(-760.003 -789.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M758.577,844.691c1.041-1.666,3.782-1.831,6.122-.37s13.886,10.555,12.845,12.221-14.275-4.726-16.615-6.188S757.536,846.357,758.577,844.691Z",
    transform: "translate(-754.545 -807.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M748.771,876.685c.785-2.044,3.748-2.808,6.619-1.706s17.436,8.595,16.652,10.639-16.623-2.134-19.493-3.236S747.987,878.729,748.771,876.685Z",
    transform: "translate(-748.579 -827.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M824.29,769.871c1.016.66,1.088,2.351.162,3.778s-6.656,8.446-7.672,7.787,3.067-8.749,3.993-10.176S823.274,769.211,824.29,769.871Z",
    transform: "translate(-790.878 -761.828)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M829.586,791.736c1.034,1.109.609,3.184-.947,4.635S818,804.611,816.968,803.5s6.372-9.694,7.928-11.145S828.553,790.628,829.586,791.736Z",
    transform: "translate(-791.034 -775.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M832.641,815.759c1.064,1.362.376,3.678-1.537,5.172s-12.9,8.3-13.968,6.942,8.2-10.38,10.115-11.874S831.577,814.4,832.641,815.759Z",
    transform: "translate(-791.147 -789.926)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M836.023,844.691c1.041,1.666-.012,4.2-2.351,5.664s-15.574,7.854-16.615,6.188,10.505-10.759,12.845-12.221S834.982,843.025,836.023,844.691Z",
    transform: "translate(-791.11 -807.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M839.159,876.685c.785,2.044-.906,4.595-3.777,5.7s-18.709,5.28-19.493,3.236,13.781-9.537,16.652-10.639S838.374,874.641,839.159,876.685Z",
    transform: "translate(-790.405 -827.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M812.553,793.714a.378.378,0,0,1,.757,0v50.127a.378.378,0,0,1-.757,0Z",
    transform: "translate(-788.351 -776.58)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.395 67.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M920.572,808.6c.8.337,1.056,1.517.582,2.634s-3.63,6.76-4.426,6.422,1.071-6.528,1.545-7.645S919.776,808.267,920.572,808.6Z",
    transform: "translate(-890.55 -808.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M903.7,816.361c.848-.165,1.724.667,1.956,1.859s.77,7.634-.078,7.8-2.762-6.01-2.994-7.2S902.852,816.526,903.7,816.361Z",
    transform: "translate(-881.843 -813.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M889.036,827.459c.98-.457,2.3.288,2.937,1.665s3.246,9.036,2.266,9.493-5.173-6.461-5.816-7.838S888.056,827.916,889.036,827.459Z",
    transform: "translate(-872.859 -820.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M877.41,841.432c1.068-.617,2.636.1,3.5,1.6s4.586,9.942,3.518,10.559-6.52-6.826-7.385-8.326S876.342,842.049,877.41,841.432Z",
    transform: "translate(-865.655 -828.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M863.653,858.368c1.134-.824,2.991-.2,4.149,1.392s6.365,10.695,5.231,11.519-8.181-6.942-9.338-8.535S862.519,859.192,863.653,858.368Z",
    transform: "translate(-857.154 -839.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M848.436,877.188c1.066-1.143,3.23-.856,4.835.641s9.238,10.347,8.173,11.489-10.427-5.855-12.032-7.351S847.37,878.331,848.436,877.188Z",
    transform: "translate(-847.853 -850.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M923.589,828.143c.5.708.092,1.846-.9,2.542s-6.661,3.809-7.157,3.1,4.368-4.969,5.362-5.665S923.094,827.435,923.589,828.143Z",
    transform: "translate(-889.905 -820.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M920.943,845.781c.387,1.01-.448,2.269-1.866,2.814s-9.24,2.608-9.627,1.6,6.806-4.71,8.224-5.254S920.555,844.771,920.943,845.781Z",
    transform: "translate(-886.138 -831.003)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M916.262,863.464c.34,1.186-.734,2.534-2.4,3.011s-10.756,2.044-11.1.859,8.2-4.674,9.866-5.152S915.922,862.279,916.262,863.464Z",
    transform: "translate(-881.986 -841.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M910.691,884.635c.243,1.38-1.131,2.777-3.07,3.118s-12.4,1.033-12.646-.347,9.826-4.31,11.765-4.652S910.447,883.255,910.691,884.635Z",
    transform: "translate(-877.145 -854.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M905.093,907.885c-.028,1.562-1.828,2.8-4.021,2.759s-13.789-1.507-13.761-3.069,11.666-2.626,13.86-2.587S905.12,906.323,905.093,907.885Z",
    transform: "translate(-872.383 -868.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M892.1,837.949a.378.378,0,1,1,.7.283L879.4,871.4a.378.378,0,1,1-.7-.283Z",
    transform: "translate(-867.014 -826.666)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M436.824,832.8q-5.421-8.619-24.738-8.62c-19.318,0-15.871-10.425-35.9-10.425s-8-39.4-56.705-41.484S281.794,795.2,266.769,795.2s-23.1-12.259-41.5-11.393-25.814,28.388-33.207,29.944-1.908-5.446-22.18-5.446q-20.271,0-28.619,15.872-11.63,8.62,24.144,8.62c8.78,0,32.963-2.8,59.862-3.579,15.18-.439,42.893,7.936,77.749,7.936,16.456,0,30.558-3.741,62.724-4.357Q397.91,832.183,436.824,832.8Z",
    transform: "translate(-138.412 -718.43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6536);
export default __webpack_public_path__ + "static/media/Group 6536.27065d11e5c8dee1a3f946f67c28704d.svg";
export { ForwardRef as ReactComponent };